import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const phases = [{
    num: '1',
    title: 'Fase de Activación',
    desc: 'Despiertas tu grasa parda con micro-estímulos térmicos diarios.'
  }, {
    num: '2',
    title: 'Fase de Recarga',
    desc: 'Implementas la Nutrición Inversa para estabilizar tus hormonas.'
  }, {
    num: '3',
    title: 'Fase de Mantenimiento',
    desc: 'Sincronizas tus ritmos circadianos para quemar grasa visceral durante el sueño.'
  }];
  return <section className="py-24 bg-gray-50" data-id="element-148">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-149">
        <FadeIn data-id="element-150">
          <h2 className="mb-16 text-3xl font-bold text-center text-gray-900 md:text-4xl" data-id="element-151">
            Cómo funciona el protocolo
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-152">
          {/* Vertical line connecting steps */}
          <div className="absolute left-[28px] top-4 bottom-4 w-0.5 bg-amber-200 hidden md:block" data-id="element-153"></div>

          <div className="space-y-12" data-id="element-154">
            {phases.map((phase, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-155">
                <div className="relative flex flex-col md:flex-row items-start gap-6" data-id="element-156">
                  <div className="flex-shrink-0 z-10" data-id="element-157">
                    <div className="flex items-center justify-center w-14 h-14 bg-amber-500 text-white text-2xl font-bold rounded-full shadow-lg shadow-amber-500/30" data-id="element-158">
                      {phase.num}
                    </div>
                  </div>
                  <div className="pt-2" data-id="element-159">
                    <h3 className="mb-3 text-2xl font-bold text-gray-900" data-id="element-160">
                      {phase.title}
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-161">
                      {phase.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}